function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-list",
  "data-name": "Icon feather-list",
  transform: "translate(-3.5 -8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_263",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 263",
  d: "M12,9H26.444",
  transform: "translate(-1.944)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_264",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 264",
  d: "M12,18H26.444",
  transform: "translate(-1.944 -2.333)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_265",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 265",
  d: "M12,27H26.444",
  transform: "translate(-1.944 -4.667)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_266",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 266",
  d: "M4.5,9h0",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_267",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 267",
  d: "M4.5,18h0",
  transform: "translate(0 -2.333)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_268",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 268",
  d: "M4.5,27h0",
  transform: "translate(0 -4.667)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.5,
    height: 15.333,
    viewBox: "0 0 21.5 15.333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.0ab128ce.svg";
export { ForwardRef as ReactComponent };